import { Component, OnInit } from '@angular/core';
import { TenantService } from '../../../core/services/tenant.service';
import { TenantConfig } from '../../../core/models/TenantConfig.model';

@Component({
  selector: 'app-hero',
  standalone: false,
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent implements OnInit {
  config: TenantConfig | null = null;

  constructor(private tenantService: TenantService) {}

  ngOnInit(): void {
    this.tenantService.tenantConfig$.subscribe((cfg) => {
      this.config = cfg;
    });
  }
}
